var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopyClipboardM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30H11a1 1 0 01-1-1V15.5a1 1 0 011-1h2.08a1 1 0 010 2H12V28h11.5v-1.08a1 1 0 012 0V29a1 1 0 01-1 1zm4.5-5.5H16.5a1 1 0 01-1-1V11a1 1 0 011-1H29a1 1 0 011 1v12.5a1 1 0 01-1 1zm-11.5-2H28V12H17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconCopyClipboardM;